import { gql, TypedDocumentNode } from '@common/hooks';
import { UserType } from '@identity/graphql';
import { Tier } from '@institutions/graphql';

export type StaffingRequestSupplierVisibility = {
  id: string;
  canBypassVisibilityOffset: { value: boolean };
  bypassedVisibility: boolean;
  visibilityOffset: number;
  visibleAtOffset: number;
  visibleAt: string;
  visibleBy: Pick<UserType, 'id' | 'firstName'>;
};

export type StaffingRequestTiersVisibility = Pick<Tier, 'id' | 'name'> & {
  supplierVisibilities: StaffingRequestSupplierVisibility[];
};

type StaffingRequestTiersVisibilityQueryResponse = {
  staffingRequestTiersVisibility: {
    hidden: StaffingRequestTiersVisibility[];
    visible: StaffingRequestTiersVisibility[];
  };
};

type StaffingRequestTiersVisibilityQueryVariables = {
  staffingRequestId: string;
};

export const STAFFING_REQUEST_TIERS_VISIBILITY_QUERY: TypedDocumentNode<
  StaffingRequestTiersVisibilityQueryResponse,
  StaffingRequestTiersVisibilityQueryVariables
> = gql`
  query StaffingRequestTiersVisibilityQuery($staffingRequestId: ID!) {
    staffingRequestTiersVisibility(staffingRequestId: $staffingRequestId) {
      hidden {
        id
        name
        supplierVisibilities(staffingRequestId: $staffingRequestId) {
          id
          visibilityOffset
          visibleAt
          visibleAtOffset
          visibleBy {
            id
            firstName
          }
          canBypassVisibilityOffset {
            value
          }
          bypassedVisibility
        }
      }
      visible {
        id
        name
        supplierVisibilities(staffingRequestId: $staffingRequestId) {
          id
          visibilityOffset
          visibleAt
          visibleAtOffset
          visibleBy {
            id
            firstName
          }
          canBypassVisibilityOffset {
            value
          }
          bypassedVisibility
        }
      }
    }
  }
`;
